import { render, staticRenderFns } from "./CitizensTable.vue?vue&type=template&id=3cbda6ba&scoped=true&"
import script from "./CitizensTable.vue?vue&type=script&lang=js&"
export * from "./CitizensTable.vue?vue&type=script&lang=js&"
import style0 from "./CitizensTable.vue?vue&type=style&index=0&id=3cbda6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbda6ba",
  null
  
)

export default component.exports